module.exports = __webpack_public_path__ + "img/icon-9.d9f20c4d.svg";